import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Meta
export const getMetaService = () => {
  return http.get(`${base_url}/meta`);
};
// End Meta

// Start Geo
export const getGeoService = (params) => {
  return http.get(`${base_url}/geo`, { params });
};
// End Geo

// Start Categories
export const getCategoriesService = (params) => {
  return http.get(`${base_url}/categories`, { params });
};
// End Categories

// Start Products
export const getProductsService = (params) => {
  return http.get(`${base_url}/products`, { params });
};
export const getProductService = (id) => {
  return http.get(`${base_url}/product/${id}`);
};
// End Products

// Start Payment
export const verifyPaymentService = (body) => {
  return http.patch(`${base_url}/payment/verify`, body);
};
// End Payment
